// Visuals and react imports
import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap/dist/js/bootstrap.bundle.min";
import "../node_modules/react-grid-layout/css/styles.css";
import "../node_modules/react-resizable/css/styles.css";
import './App.css';
import React from "react";

// Page routing
import { Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import AllTurbines from './pages/AllTurbines';
import RegForm from './pages/RegForm';
import CustomerHome from './pages/CustomerHome';
import ProtectedRoute from './components/ProtectedRoute';
import packageJson from '../package.json';
import DownloadForm from './components/forms/DownloadForm';
import { useAuth0 } from '@auth0/auth0-react';

// App-based components
import NavBar from './navigation/Navbar';
import { RegFormGrid } from './grids/RegFormGrid';

const WithNavbarLayout = ({ children }) => (
  <>
    <NavBar />
    <div>{children}</div>
    <p className='d-flex text-center justify-content-center'>v{packageJson.version} Intergrid LLC©2025</p>
  </>
)

// Login page component
const LoginPage = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

  React.useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      // Automatically trigger Auth0 login when user visits /login
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isAuthenticated) {
    // If already authenticated, redirect to home
    window.location.href = '/';
    return <div>Redirecting...</div>;
  }

  return <div>Redirecting to login...</div>;
};

function App() {
  return (
    <>
      <Routes>
        {/* Routes sans Navbar */}
        <Route path="/registration" element={<RegForm />} />
        <Route path="/login" element={<LoginPage />} />

        {/* Routes with Navbar */}
        <Route element={<WithNavbarLayout />}>
          <Route path="/" element={
            <ProtectedRoute>
              <AllTurbines />
            </ProtectedRoute>} />
          <Route path="/turbine" element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>} />
          <Route path="/download" element={
            <ProtectedRoute>
              <DownloadForm />
            </ProtectedRoute>} />
          <Route path="/turbine/:uid" element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>} />
          <Route path="/mysite/:uid" element={
            <ProtectedRoute>
              <CustomerHome />
            </ProtectedRoute>} />
          <Route path="/form" element={<RegFormGrid />} />
        </Route>
      </Routes>
    </>
  )
}

export default App;
